<template>
  <HeaderProvince :to="'/'" @change_City_From="changeFrom" @change_City_To="changeTo" />

  <div id="refresh-container">
    <div style="padding-top: 6rem;">
      <Placeholder v-if="loading" />

      <div v-else style="background-color: white">
        <!-- <FixLimited v-if="freeCalls !== 'false'" :freeCalls="freeCalls" /> -->
        

        <div class="section" v-for="(cargo, index) in cargos" :key="cargo.id" :class="[
          index !== 0 ? 'mt-3 mb-3' : '',
          index === 0 && isFreeCallsExceeded ? 'pt-45' : '',
          index === 0 ? 'mt-3 mb-3' : '',
          // index === 0 && !isFreeCallsExceeded ? '' : '',
        ]">
          <CardView :cargo="cargo" />
        </div>

        <button v-if="mode === 1 && loadingNext === 0" @click="nextLoadCargo" class="btn btn-success btn-block btn-lg">
          نمایش بار های بیشتر کلیک کنید...
        </button>

        <button v-else-if="loadingNext === 1" class="btn btn-warning btn-lg btn-block" type="button" disabled>
          <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
          درحال بارگذاری ...
        </button>
      </div>

      <a href="#" class="button goTop show">
        <ion-icon name="arrow-up-outline"></ion-icon>
      </a>
    </div>
  </div>
</template>

<script>
import Placeholder from "@/components/Placeholder.vue";
import CardView from "@/views/cargo/components/CardView.vue";
import HeaderProvince from "@/components/HeaderSearchProvince.vue";
// import FixLimited from "@/components/FixLimited.vue";
import axios from "axios";
import PullToRefresh from "pulltorefreshjs";
import Swal from "sweetalert2";
import router from "@/router";
import delivery_methods from "@/delivery_methods";

export default {
  name: "Master",
  components: {
    CardView,
    Placeholder,
    HeaderProvince,
    // FixLimited
  },
  data() {
    return {
      from: '',
      to: '',
      mode: 0,
      loading: false,
      loadingNext: 0,
      cargos: [],
      freeCalls: '',
      page: 1,
      total: 0,
      cityTo: [],
      cityFrom: [],
      citiesOfProvince: [],
      cityIds: [],
      selectCity: 'انتخاب شهر',
      cities: {
        from: null,
        to: null
      },
      location: {
        latitude: null,
        longitude: null,
      },
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      },
      postData: {
        selectedLoadingCitiesIds: '',
        selectedDischargeCitiesIds: '',
        fleet_id: '',
      },
      ptrInstance: null,
    };
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },
    isFreeCallsExceeded() {
      return this.freeCalls !== 'false' && this.freeCalls > 6;
    }
  },
  methods: {
    handleSelectAll() {
      if (this.selectAll) {
        this.cityIds = []; // اگر "همه" انتخاب شد، بقیه رو پاک کن
      }
    },
    handleCitySelection() {
      if (this.cityIds.length > 0 && this.selectAll) {
        this.selectAll = false; // اگر یکی از شهرها انتخاب شد، "همه" رو غیرفعال کن
      }
    },
    changeFrom(value) {
      if (value == 0) {
        this.getLocation();
      }
      else {
        this.postData.selectedLoadingCitiesIds = value;
        this.$router.push("/nearLoads?" +
          'from=' + value + '&' +
          'to=' + this.postData.selectedDischargeCitiesIds
        );
        this.searchProvince();
        if (this.postData.selectedLoadingCitiesIds == 8) {
          this.getCitiesOfProvince();
        }
      }

    },
    changeTo(value) {
      this.postData.selectedDischargeCitiesIds = value;
      this.$router.push("/nearLoads?" +
        'from=' + this.postData.selectedLoadingCitiesIds + '&' +
        'to=' + value
      );
      this.searchProvince();
    },
    searchProvince() {
      this.loading = true;
      axios.post(`https://xpanel.s-bar.ir/api/requestCitiesList`, this.postData)
        .then((res) => {
          this.cityTo = res.data.selectedDischargeCitiesIds.map((a) => a.id);
          this.cityFrom = res.data.selectedLoadingCitiesIds.map((a) => a.id);
          this.cityTo.forEach((element, index) => {
            this.cityTo[index] = "\n  " + element;
          });

          this.cityFrom.forEach((element, index) => {
            this.cityFrom[index] = "\n  " + element;
          });
          this.cities.from = JSON.stringify(this.cityFrom);
          this.cities.to = JSON.stringify(this.cityTo);

          axios.post(`https://xpanel.s-bar.ir/api/driver/searchLoadForDriver`,
            {
              selectedLoadingCitiesIds: this.cities.from,
              selectedDischargeCitiesIds: this.cities.to,
              fleet_id: this.postData.fleet_id,
            },
            this.axiosConfig
          )
            .then((response) => {

              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
              if (response.data.data.length == 0) {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: 'بار مورد نظر یافت نشد',
                  showConfirmButton: true,
                  confirmButtonText: "تایید",
                  // timer: 2000,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.loading = false;
                    this.cargos = [];
                    window.location.href = "/nearLoads";
                  }
                });
              } else {
                response.data.data.length == 25 ? this.mode = 1 : this.mode = 0;
                this.loading = false;
                this.cargos = response.data.data;
                setTimeout(() => {
                  const savedPosition = localStorage.getItem('scrollPosition');
                  window.scrollTo(0, savedPosition);
                }, 100);
                this.show = true;
              }
            });
        }).catch((res) => {
          console.log(res);
        });
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
        this.showError({ code: 0 });
      }
    },
    getCitiesOfProvince() {
      axios.get(`https://xpanel.s-bar.ir/api/getCitiesOfProvince/8`, this.axiosConfig)
        .then((response) => {
          console.log('awdawd');
          this.citiesOfProvince = response.data.data.cities
        });
    },
    showPosition(position) {
      const { latitude, longitude } = position.coords;
      this.location = { latitude, longitude };

      localStorage.setItem("latitude", latitude);
      localStorage.setItem("longitude", longitude);
      localStorage.setItem("locationTimestamp", Date.now());

      this.page = 1;
      this.loading = true;

      axios.post(`https://xpanel.s-bar.ir/api/driver/searchTheNearestCargo`, {
        latitude,
        longitude,
        page: this.page
      }, this.axiosConfig)
        .then(({ data }) => {
          console.log(data);
          if (data.data.total == 0) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: 'راننده گرامی',
              text: 'تا فاصله ی 400 کیلومتری شما باری ثبت نشده است ',
              showConfirmButton: true,
              confirmButtonText: "تایید",
              // timer: 2000,
            }).then((result) => {
              if (result.isConfirmed) {
                router.push({ name: 'home' })
              }
            });
          }
          this.freeCalls = data.data.freeCalls;
          this.total = data.data.total;
          this.current_page = data.data.current_page;
          this.mode = data.data.loads.length > 0 ? 1 : 0;
          this.cargos = data.data.loads;
          this.updateLocation(this.location)
        })
        .catch(this.handleApiError)
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            const savedPosition = localStorage.getItem('scrollPosition');
            window.scrollTo(0, savedPosition || 0);
          }, 100);
        });
    },
    updateLocation(location) {
      axios.get(
        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=` + location.latitude + `&longitude=` + location.longitude + `&localityLanguage=fa`)
        .then((response) => {
          localStorage.setItem("city", response.data.city);
          axios.put(`https://xpanel.s-bar.ir/api/driver/updateLocation`, {
            latitude: location.latitude,
            longitude: location.longitude,
            city: response.data.city,
          }, this.axiosConfig).then(() => {
            //
          }).catch(() => {
            //
          });
        });
    },
    nextLoadCargo() {
      this.loadingNext = 1;
      this.page += 1;

      axios.post(`https://xpanel.s-bar.ir/api/driver/searchTheNearestCargo`, {
        latitude: this.location.latitude,
        longitude: this.location.longitude,
        page: this.page
      }, this.axiosConfig)
        .then(({ data }) => {
          if (data.data.loads.length === 0) {
            this.mode = 0;
          } else {
            this.cargos.push(...data.data.loads);
          }
        })
        .catch(console.error)
        .finally(() => {
          this.loadingNext = 0;
        });
    },
    showError(error) {
      const messages = {
        1: "لطفا موقعیت مکانی خود را روشن کنید.",
        2: "اطلاعات موقعیت مکانی در دسترس نیست.",
        3: "درخواست موقعیت‌یابی با زمان‌سنجی مواجه شد.",
        0: "خطای ناشناخته در موقعیت‌یابی رخ داده است."
      };
      alert(messages[error.code] || "خطای ناشناخته");
    },
    handleApiError(error) {
      if (error.response?.status === 401) {
        Swal.fire({
          title: "راننده محترم!",
          text: "شماره شما توسط دستگاه دیگری استفاده شده است.",
          icon: "error",
          confirmButtonText: "ورود مجدد!",
        }).then(() => {
          Object.keys(localStorage).forEach((key) => {
            if (!['version'].includes(key)) {
                localStorage.removeItem(key);
              }
            });
          router.push({ name: 'login' });
        });
      }
    },
    initPullToRefresh() {
      if (this.ptrInstance) {
        this.ptrInstance.destroy();
      }
      this.ptrInstance = PullToRefresh.init({
        mainElement: '#refresh-container',
        onRefresh: this.refreshFromCacheOrLocation
      });
    },
    refreshFromCacheOrLocation() {
      const savedLat = localStorage.getItem("latitude");
      const savedLng = localStorage.getItem("longitude");
      const savedTime = localStorage.getItem("locationTimestamp");

      const now = Date.now();
      const isRecent = savedLat && savedLng && savedTime && (now - savedTime < 5 * 60 * 1000);
      this.loading = true;

      if (isRecent) {
        this.showPosition({
          coords: {
            latitude: parseFloat(savedLat),
            longitude: parseFloat(savedLng)
          }
        });
      } else {
        this.getLocation();
      }
    },
    saveScrollPosition() {
      localStorage.setItem('scrollPosition', window.scrollY);
    }
  },
  beforeMount() {
    this.refreshFromCacheOrLocation();
  },
  mounted() {
    this.initPullToRefresh();
    if (this.$route.query.from == 8) {
      this.getCitiesOfProvince();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.saveScrollPosition();
    next();
  },
  beforeUnmount() {
    this.ptrInstance?.destroy();
  }
};
</script>

<style scoped>
.pt-45 {
  padding-top: 2rem !important;
}

#webpack-dev-server-client-overlay {
  display: none;
}
</style>